import { React } from "react";

export default function HeaderBackground(props) {
  return (
    <div className="header-background">
      <h1 className="title">{props.title}</h1>
    </div>
  );
}
